import { render, staticRenderFns } from "./BrandHeader.vue?vue&type=template&id=bfeaf2b0&scoped=true"
import script from "./BrandHeader.vue?vue&type=script&lang=js"
export * from "./BrandHeader.vue?vue&type=script&lang=js"
import style0 from "./BrandHeader.vue?vue&type=style&index=0&id=bfeaf2b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfeaf2b0",
  null
  
)

export default component.exports